import { Component, ElementRef, AfterViewInit, ViewChild, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as OT from '@opentok/client';

@Component({
  selector: 'app-subscriber',
  templateUrl: './subscriber.component.html'
})

export class SubscriberComponent implements OnInit {
  @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
  @Output() videoClosed = new EventEmitter();
  @Input() session: OT.Session;
  @Input() stream: OT.Stream;
  subscriber: OT.Subscriber;
  constructor() { }

  ngOnInit() {
    this.subscriber = this.session.subscribe(this.stream, this.subscriberDiv.nativeElement, {
    }, (err) => {
      if (err) {
        alert(err.message);
      }
    });
  }

  public closeVideo() {
    this.videoClosed.emit();
  }
}
